import { applySnapshot, types } from 'mobx-state-tree';
import { createThunk, model, Model } from 'mst-collection';

import { Api, IWatchProgressResponse } from '@api';

export class UserWatchProgress extends Model({
  watchedCount: types.optional(types.number, 0),
  totalCount: types.optional(types.number, 0),
}) {
  get completionPercent() {
    // Dividing by 0 gives NaN
    if (this.totalCount === 0) {
      return 0;
    }

    return this.watchedCount / this.totalCount;
  }

  private _updateModel(newData: IWatchProgressResponse) {
    applySnapshot(this, newData);
  }

  fetch = createThunk(() => {
    return async function fetch(this: UserWatchProgress) {
      const res = await Api.Profile.getWatchProgress();

      this._updateModel(res.data);
    };
  });
}

export const UserWatchProgressModel = model(UserWatchProgress);
